import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasGroupToolbarActionClicked.meta';

export type UseTrackCanvasGroupToolbarActionClickedParams = {
  canvas_id: string;
  action_taken: 'prompt' | 'smart_resize' | 'ungroup' | 'platform_preview' | 'save_to_workspace' | 'crop';
};

export const useTrackCanvasGroupToolbarActionClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasGroupToolbarActionClicked = useCallback(
    (params: UseTrackCanvasGroupToolbarActionClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasGroupToolbarActionClicked };
};
